import React, { Component } from "react";

import Typography from "material-ui/Typography";
import Grid from "material-ui/Grid";

import RelatedNav from "./RelatedNav";

class Service extends Component {
  render() {
    const { service } = this.props;

    return (
      <Grid item md={8} lg={9}>
        <Typography variant="display2" gutterBottom className="entityHeading">
          {service.name}
        </Typography>
        <Typography variant="body2" gutterBottom style={{ padding: "10px" }}>
          <pre style={{ whiteSpace: "pre-line", fontFamily: "inherit" }}>
            {service.description}
          </pre>
        </Typography>
        {service.doktori || service.aparati ? (
          <RelatedNav service={service} />
        ) : (
          ""
        )}
      </Grid>
    );
  }
}

export default Service;



// WEBPACK FOOTER //
// ./src/components/Service.js